// src/data/mock.js
// Data resmi PT SATHRUSI KOMODITI INDONESIA (SHAKTI)
// NOTE: Komponen kamu sudah pakai encodeURI() untuk img src.

export const companyInfo = {
  name: "PT SATHRUSI KOMODITI INDONESIA",
  brand: "SHAKTI",
  keyword: "bumbushakti",
  marketingArea: "Nasional",

  tagline: "Indonesian Spices and Seasoning Manufacture",

  address:
    "KP. TAJUR RT.001 RW.004, KEL/DESA. PASIR MUNCANG, KECAMATAN. CIGOMBONG, KAB. BOGOR 16730",

  phone: "0251 2901 360",
  whatsapp: "6282299365878",
  emailPrimary: "Admmarketingsathrusi@gmail.com",
  emailSecondary: "pt.skindonesia@gmail.com",
  websites: ["www.bumbushakti.com"],

  socials: {
    instagram: "",
    facebook: "",
    twitter: "",
  },

  logo: "/assets/brand/logo.jpg",

  // hero watermark/logo besar
  heroBackground: "/assets/brand/logo1.png",
};

export const hero = {
  badge: "Halal • CPPOB • Izin Edar • HKI • Pemasaran Nasional",
  title: "Bumbu Pilihan",
  titleHighlight: "Cita Rasa Keluarga Indonesia",
  subtitle:
    "Produk bumbu dan rempah brand SHAKTI dengan proses produksi higienis, legalitas lengkap, dan siap memenuhi kebutuhan retail hingga industri di seluruh Indonesia.",
  cta: "Hubungi via WhatsApp",
  ctaSecondary: "Lihat Produk",
  image:
    "https://images.unsplash.com/photo-1625921133217-8d978f7872b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxjaGlsaSUyMHBvd2RlcnxlbnwwfHx8fDE3NjY1NjgwNDB8MA&ixlib=rb-4.1.0&q=85",
};

export const about = {
  title: "Tentang Kami",
  description:
    "PT SATHRUSI KOMODITI INDONESIA adalah perusahaan yang memproduksi bumbu masak dan rempah dengan brand SHAKTI. Kami berkomitmen menghadirkan produk yang konsisten rasanya, aman, dan diproduksi dengan standar kebersihan yang baik. Kami melayani kebutuhan rumah tangga, grosir, distributor, hingga pasokan untuk kebutuhan usaha dan industri (sesuai kesepakatan).",
  stats: [
    { number: "Nasional", label: "Wilayah Pemasaran" },
    { number: "Lengkap", label: "Pilihan Kemasan" },
    { number: "Resmi", label: "Legalitas Produk" },
  ],
  image: "/assets/facility/machine.jpeg",
};

/**
 * FASILITAS (sesuai revisi video):
 * - Yang ada orang / manual / gudang kardus / pipa-ducting: hidden: true
 * - Komponen FasilitasKamiSection harus filter: facilityGallery.filter(x => !x.hidden)
 */
export const facilityGallery = [
  {
    image: "/assets/facility/gedung.jpeg",
    title: "Gedung Produksi",
    caption: "Gedung produksi PT SATHRUSI KOMODITI INDONESIA.",
    hidden: false,
  },
  {
    image: "/assets/facility/DSC01480.JPG",
    title: "Area Produksi Bersih",
    caption: "Area kerja tertata rapi untuk mendukung standar kebersihan.",
    hidden: false,
  },

  // DIHAPUS (ada orang/operator)
  {
    image: "/assets/facility/DSC01516.JPG",
    title: "Proses Produksi",
    caption: "Aktivitas produksi dengan mesin dan operator.",
    hidden: true,
  },

  // DIHAPUS (gudang/kardus)
  {
    image: "/assets/facility/box.png",
    title: "Gudang & Penyimpanan",
    caption: "Penyimpanan karton tersusun rapi.",
    hidden: true,
  },

  // DIHAPUS (ada orang/tim)
  {
    image: "/assets/facility/DSC01490.JPG",
    title: "Standar Higienitas Tim",
    caption: "Tim menggunakan APD sesuai prosedur kerja.",
    hidden: false,
  },

  // OK: mesin
  {
    image: "/assets/facility/mesin1.jpeg",
    title: "Mesin Produksi",
    caption: "Rangkaian mesin produksi untuk mendukung proses yang higienis.",
    hidden: false,
  },
  {
    image: "/assets/facility/mesin2.jpeg",
    title: "Mesin Produksi",
    caption: "Area mesin produksi bersih dan tertata.",
    hidden: false,
  },

  // DIHAPUS (pipa/ducting yang di-X)
  {
    image: "/assets/facility/mesin3.jpeg",
    title: "Mesin Produksi",
    caption: "Instalasi mesin produksi dengan sistem sirkulasi/ducting.",
    hidden: false,
  },
];

/**
 * PRODUK (sesuai revisi video):
 * - Tidak pakai variasi gramasi di listing → 1 kartu per produk utama
 * - "cabe satu" + "cabe kasar satu"
 * - Balado satu, Ayam Bawang satu
 * - Produk yang belum ada foto → hidden: true (jangan tampil dulu)
 */
export const productShowcase = [
  // ===== CABE (cabe satu) =====
  {
    id: "cabe-bubuk",
    name: "Cabe Bubuk",
    description: "Cabe bubuk halus untuk masak harian dan kebutuhan usaha.",
    packaging: "Standing Pouch",
    image: "/assets/products/CBEP 250g.png", // sementara (nanti ganti foto asli)
    tags: ["Cabe Bubuk"],
    hidden: false,
  },
  {
    id: "cabe-bubuk-kasar",
    name: "Cabe Bubuk Kasar",
    description: "Cabe bubuk kasar cocok taburan, topping, dan bumbu praktis.",
    packaging: "Sachet",
    image: "/assets/products/cabe-bubuk-kasar 7g.jpg",
    tags: ["Cabe Bubuk"],
    hidden: false,
  },

  // ===== CABEAI =====
  {
    id: "cabeai-ori-sachet",
    name: "CABEAI Rasa Original",
    description: "Sambal tabur bubuk original, pedas gurih dalam sachet.",
    packaging: "Sachet",
    image: "/assets/products/cabeai ori 7g.png",
    tags: ["Sambal Tabur"],
    hidden: false,
  },
  {
    id: "cabeai-teri-sachet",
    name: "CABEAI Rasa Teri",
    description: "Sambal tabur bubuk teri, pedas gurih dalam sachet.",
    packaging: "Sachet",
    image: "/assets/products/cabeai teri 7g.png",
    tags: ["Sambal Tabur"],
    hidden: false,
  },

  // Botol (biar botol sejajar)
  {
    id: "cabeai-ori-botol",
    name: "CABEAI Rasa Original",
    description: "Sambal tabur original kemasan botol, siap tabur kapan saja.",
    packaging: "Botol",
    image: "/assets/products/MOKUP BOTOL CABEAI .png",
    tags: ["Sambal Tabur"],
    hidden: false,
  },
  {
    id: "cabeai-teri-botol",
    name: "CABEAI Rasa Teri",
    description: "Sambal tabur teri kemasan botol, siap tabur kapan saja.",
    packaging: "Botol",
    image: "/assets/products/MOKUP CABEAI TERI .png",
    tags: ["Sambal Tabur"],
    hidden: false,
  },

  // ===== BUMBU TABUR =====
  {
    id: "bumbu-tabur-balado",
    name: "Bumbu Rasa Balado",
    description:
      "Bumbu tabur balado praktis, cocok untuk berbagai jenis makanan.",
    packaging: "Sachet",
    image: "/assets/products/bumbu-balado.jpeg",
    tags: ["Bumbu Tabur"],
    hidden: false,
  },
  {
    id: "bumbu-tabur-ayam-bawang",
    name: "Bumbu Rasa Ayam Bawang",
    description: "Bumbu tabur ayam bawang gurih, cocok untuk semua makanan.",
    packaging: "Sachet",
    image: "/assets/products/ayam-bawang 50g.jpeg",
    tags: ["Bumbu Tabur"],
    hidden: false,
  },

  // ===== BUMBU KARI (beda kemasan masih boleh) =====
  {
    id: "kari-sp",
    name: "Bumbu Kari",
    description: "Bumbu kari bubuk dalam standing pouch, wangi dan gurih.",
    packaging: "Standing Pouch",
    image: "/assets/products/bumbu kari sp.png",
    tags: ["Bumbu Kari"],
    hidden: false,
  },
  {
    id: "kari-botol",
    name: "Bumbu Kari",
    description: "Bumbu kari bubuk kemasan botol, praktis untuk stok dapur.",
    packaging: "Botol",
    image: "/assets/products/bumbu kari.png",
    tags: ["Bumbu Kari"],
    hidden: false,
  },

  // ===== REMPAH (ketumbar masuk) =====
  {
    id: "ketumbar-sachet",
    name: "Ketumbar Bubuk",
    description:
      "Ketumbar bubuk sachet, wangi untuk bumbu masak sehari-hari.",
    packaging: "Sachet",
    image: "/assets/products/ketumbar 5g.png",
    tags: ["Rempah"],
    hidden: false,
  },
  {
    id: "lada-sachet",
    name: "Lada Bubuk",
    description: "Lada bubuk sachet, pedas hangat untuk bumbu masak praktis.",
    packaging: "Sachet",
    image: "/assets/products/lada bubuk 5gr revisi.png",
    tags: ["Rempah"],
    hidden: false,
  },

  // Botol rempah (sejajarkan botol)
  {
    id: "ketumbar-botol",
    name: "Ketumbar Bubuk",
    description: "Ketumbar bubuk botol, wangi awet untuk stok dapur.",
    packaging: "Botol",
    image: "/assets/products/KETUMBAR BUBUK.png",
    tags: ["Rempah"],
    hidden: false,
  },
  {
    id: "kunyit-botol",
    name: "Kunyit Bubuk",
    description: "Kunyit bubuk botol untuk masak, warna cerah alami.",
    packaging: "Botol",
    image: "/assets/products/KUNYIT BUBUK.png",
    tags: ["Rempah"],
    hidden: false,
  },
  {
    id: "kayu-manis-botol",
    name: "Kayu Manis Bubuk",
    description: "Kayu manis bubuk botol, harum manis untuk masak.",
    packaging: "Botol",
    image: "/assets/products/KAYU MANIS BUBUK.png",
    tags: ["Rempah"],
    hidden: false,
  },
  {
    id: "lada-botol",
    name: "Lada Bubuk",
    description: "Lada bubuk botol, pedas tajam untuk masak dan marinasi.",
    packaging: "Botol",
    image: "/assets/products/LADA BUBUK (2).png",
    tags: ["Rempah"],
    hidden: false,
  },
  {
    id: "chili-flake-botol",
    name: "Chili Flake",
    description: "Chili flake botol untuk topping, pizza, mie, dan snack.",
    packaging: "Botol",
    image: "/assets/products/CHILI FLAKE.png",
    tags: ["Flakes"],
    hidden: false,
  },

  // ===== B2B (yang sudah ada foto: tampil) =====
  {
    id: "aiplus",
    name: "Campuran Penguat Rasa",
    description: "Penguat rasa usaha, bantu masakan konsisten, hemat, dan efisien.",
    packaging: "Sachet",
    image: "/assets/products/aiplus.jpeg",
    hidden: false,
  },
  {
    id: "ekstrak-sapi",
    name: "Bumbu Rasa Daging Sapi",
    description: "Bumbu ekstrak sapi gurih, menambah cita rasa masakan.",
    packaging: "Sachet",
    image: "/assets/products/sapi.jpeg",
    hidden: false,
  },

  // ===== BELUM SIAP (belum ada foto → jangan tampil dulu) =====
  {
    id: "ekstrak-ayam",
    name: "Bumbu Rasa Daging Ayam",
    description: "Bumbu ekstrak ayam, menjaga konsistensi rasa masakan harian.",
    packaging: "Sachet",
    image: "",
    hidden: true,
  },
  {
    id: "terasi-bubuk",
    name: "Terasi Bubuk",
    description: "Terasi bubuk praktis, memperkaya aroma dan rasa masakan.",
    packaging: "Sachet",
    image: "",
    hidden: true,
  },
  {
    id: "rasa-ebi",
    name: "Bumbu Rasa Ebi",
    description: "Bumbu rasa ebi gurih, cocok untuk olahan dan camilan.",
    packaging: "Sachet",
    image: "",
    hidden: true,
  },
];


export const packagingTable = [
  {
    product:
      "Lada Bubuk / Ketumbar Bubuk / Kunyit Bubuk / Kayu Manis Bubuk / CabeAi Rasa Original / CabeAi Rasa Teri",
    packaging: "SACHET",
    gramasi:
      "7 gr, 10 gr, 25 gr, 30 gr, 50 gr, 100 gr, 200 gr, 250 gr, 500 gr, 1000 gr, 5 kg, 10 kg, 20 kg, 25 kg",
    sizeCm: "14 x 9,5",
  },
  {
    product: "Bumbu Kari Ayam & Daging",
    packaging: "SACHET",
    gramasi:
      "7 gr, 10 gr, 25 gr, 30 gr, 50 gr, 100 gr, 200 gr, 250 gr, 500 gr, 1000 gr, 5 kg, 10 kg, 20 kg, 25 kg",
    sizeCm: "18 x 12",
  },
  {
    product:
      "Lada Bubuk / Ketumbar Bubuk / Kunyit Bubuk / Kayu Manis Bubuk / CabeAi Rasa Original / CabeAi Rasa Teri / Bumbu Kari / Bumbu Tabur / Cabe Bubuk",
    packaging: "STANDING POUCH",
    gramasi: "50 g",
    sizeCm: "10 x 15",
  },
  {
    product: "CabeAi / Bumbu Kari / Bumbu Tabur / Cabe Bubuk (varian tertentu)",
    packaging: "STANDING POUCH",
    gramasi: "250 g",
    sizeCm: "14 x 23",
  },
  {
    product: "Cabe Granul / Bumbu Tabur / Cabe Bubuk (varian tertentu)",
    packaging: "STANDING POUCH",
    gramasi: "1 Kg",
    sizeCm: "23 x 29",
  },
];

export const legalDocuments = [
  { label: "CPPOB BTP", file: "/legal/CPPOB BTP SKl.pdf" },
  { label: "HAS Status", file: "/legal/HASStatus_page-0001.jpg" },
  {
    label: "Sertifikat Halal",
    file: "/legal/SERTIFIKAT HALAL SK_page-0001.jpg",
  },
  { label: "NIB", file: "/legal/NIBI SKINEW.pdf" },

  {
    label: "Izin Edar - Bumbu Kari Ayam dan Daging",
    file: "/legal/IZIN EDAR BUMBU KARI AYAM DAN DAGING.jpg",
  },
  {
    label: "Izin Edar - Bumbu Tabur Rasa Balado",
    file: "/legal/IZIN EDAR BUMBU TABUR RASA BALADO.jpg",
  },
  {
    label: "Izin Edar - Cabe Merah Bubuk Extra Pedas",
    file: "/legal/IZIN EDAR CABE MERAH BUBUK EXTRA PEDAS.jpg",
  },
  {
    label: "Izin Edar - Cabe Merah Bubuk Pedas",
    file: "/legal/IZIN EDAR CABE MERAH BUBUK PEDAS.jpg",
  },
  {
    label: "Izin Edar - CABEAI Original",
    file: "/legal/IZIN EDAR CABEAI ORIGINAL_page-0001.jpg",
  },
  { label: "Izin Edar - CABEAI Teri", file: "/legal/IZIN EDAR CABEAI TERI.jpg" },

  { label: "Izin Edar - EP Baru (1)", file: "/legal/izin edar ep baru_page-0001.jpg" },
  { label: "Izin Edar - EP Baru (2)", file: "/legal/izin edar ep baru_page-0002.jpg" },

  { label: "Izin Edar - Kacang Tanah", file: "/legal/IZIN EDAR KACANG TANAH.jpg" },
  { label: "Izin Edar - Ketumbar Bubuk", file: "/legal/IZIN EDAR KETUMBAR BUBUK.jpg" },
  { label: "Izin Edar - Lada Bubuk", file: "/legal/IZIN EDAR LADA BUBUK.jpg" },

  {
    label: "CPPOB Pangan Olahan",
    file: "/legal/IZIN SERTFIKAT CPPOB PANGAN OLAHAN.pdf",
  },
  { label: "Sertifikat - D002016048742", file: "/legal/Sertifikat - D002016048742.pdf" },
  { label: "Sertifikat - DID2018008993", file: "/legal/Sertifikat-DID2018008993.pdf" },
];

// Optional: kalau masih ada komponen lama yang memakai exports ini
export const certifications = [
  {
    id: 1,
    name: "Sertifikat Halal",
    description: "Produk didukung dokumen sertifikasi Halal.",
    icon: "CheckCircle2",
  },
  {
    id: 2,
    name: "CPPOB",
    description: "Dokumen CPPOB sebagai bukti komitmen proses produksi yang baik.",
    icon: "Shield",
  },
  {
    id: 3,
    name: "Izin Edar",
    description: "Tersedia dokumen izin edar untuk produk sesuai ketentuan.",
    icon: "Award",
  },
  {
    id: 4,
    name: "HKI",
    description: "Brand SHAKTI/CABEAI didukung bukti perlindungan merek (HKI).",
    icon: "FileCheck",
  },
];

export const features = [
  {
    id: 1,
    title: "Produksi Higienis",
    description: "Area produksi tertata dan prosedur kerja menjaga kebersihan.",
    icon: "Shield",
  },
  {
    id: 2,
    title: "Legalitas Lengkap",
    description: "Dokumen legalitas tersedia untuk membangun kepercayaan pasar.",
    icon: "Award",
  },
  {
    id: 3,
    title: "Siap Pasok Nasional",
    description: "Mendukung kebutuhan pasar dan mitra di seluruh Indonesia.",
    icon: "TrendingUp",
  },
];
